<template>
  <v-card class="elevation-10">
    <v-card-title> Данные организации</v-card-title>

    <v-card-text>
      <v-form>
        <v-text-field v-model="inn" label="Инн" type="text" readonly/>

        <v-text-field v-model="name" label="Название" type="text" readonly/>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CompanyDetails",

  data() {
    return {
      inn: '',
      name: ''
    };
  },
  created() {
    this.inn = this.$store.getters.login.company.inn;
    this.name = this.$store.getters.login.company.name;
  }
}
</script>

<style scoped>

</style>